import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import SearchIcon from "@material-ui/icons/Search";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { DelayInput } from "react-delay-input";
import InputSelect from "../components/common/InputSelect";
import Loader from "../components/common/loader/Loader";
import PitcherList from "../components/common/PitcherList";
import { UserContext } from "../contexts/UserContext";
import "./GameModify.css";
import PitcherChangeConfirm from "./games/gameComponents/PitcherChangeConfirm";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor"; // Required for editing
import { FaSave, FaTrash } from "react-icons/fa";
import PitcherSearch from "../components/common/PitcherSearch";

export default function GameModify(props) {
  const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    appBar: {
      position: "relative",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "600px",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        // width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const [flag, setFlag] = useState(false);
  const [idAction, setIdAction] = useState(0);
  const [pitcherSide, setPitcherSide] = useState("");
  const [open, setOpen] = React.useState(true);
  const [pitchers, setPitchers] = React.useState([]);
  const [idSport, setIdSport] = React.useState("");
  const [idLeague, setIdLeague] = React.useState(0);
  const [visitorScore, setVisitorScore] = React.useState(0);
  const [homeScore, setHomeScore] = React.useState(0);
  const [visitorPitcher, setVisitorPitcher] = React.useState("");
  const [visitorPitcherOld, setVisitorPitcherOld] = React.useState("");
  const [homePitcherOld, setHomePitcherOld] = React.useState("");
  const [homePitcher, setHomePitcher] = React.useState("");
  const [gameStat, setGameStat] = React.useState("");
  const [graded, setGraded] = React.useState(false);
  const [gameType, setGameType] = React.useState(0);
  const [hookups, setHookUps] = React.useState(false);
  const [local, setLocal] = React.useState(false);
  const [online, setOnline] = React.useState(false);
  const [shortGame, setShortGame] = React.useState(false);
  const [eventDate, setEventDate] = React.useState("");
  const [dateChanged, setDateChanged] = React.useState(false);
  const [timeChanged, setTimeChanged] = React.useState(false);
  const [pitcherChanged, setPitcherChanged] = React.useState(0);
  const [period, setPeriod] = React.useState(0);
  const [gradedDate, setGradedDate] = React.useState("");
  const [numTeams, setNumTeams] = React.useState(0);
  const [idEvent, setIdEvent] = React.useState(0);
  const [hasChildren, setHasChildren] = React.useState(false);
  const [idTeamVisitor, setIdTeamVisitor] = React.useState(0);
  const [idTeamHome, setIdTeamHome] = React.useState(0);
  const [idBannerType, setIdBannerType] = React.useState(0);
  const [gameDateTime, setGameDateTime] = React.useState("");
  const [league, setLeague] = React.useState([]);
  const [leagueID, setLeagueID] = React.useState(0);
  const [typeID, setTypeID] = React.useState(0);
  const [type, setType] = React.useState([]);
  const [familyGame, setFamilyGame] = React.useState(0);
  const [parentGame, setParentGame] = React.useState(0);
  const [description, setDescription] = React.useState("");
  const [visitorNumber, setVisitorNumber] = React.useState(0);
  const [visitorTeam, setVisitorTeam] = React.useState("");
  const [homeNumber, setHomeNumber] = React.useState(0);
  const [homeTeam, setHomeTeam] = React.useState("");
  const [visitorSpread, setVisitorSpread] = React.useState(0);
  const [visitorSpreadOdds, setVisitorSpreadOdds] = React.useState(0);
  const [overTotal, setOverTotal] = React.useState(0);
  const [overOdds, setOverOdds] = React.useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [visitorMoneyline, setVisitorMoneyline] = React.useState(0);
  const [newMoneyline, setNewMoneyline] = React.useState(0);
  const [homeSpread, setHomeSpread] = React.useState(0);
  const [homeSpreadOdds, setHomeSpreadOdds] = React.useState(0);
  const [underTotal, setUnderTotal] = React.useState(0);
  const [underOdds, setUnderOdds] = React.useState(0);
  const [homeMoneyline, setHomeMoneyline] = React.useState(0);
  const [idGame, setIdGame] = React.useState(0);
  const [normalGame, setNormalGame] = React.useState(0);
  const [idGameType, setIdGameType] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const [acceptAutoChanges, setAcceptAutoChanges] = React.useState(false);
  const [isChange, setIsChange] = React.useState(false);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [result, setResult] = React.useState(0);
  const [valueHasChanged, setValueHasChanged] = useState(1);
  const [contender, setContender] = useState(1);
  const [odds, setOdds] = useState("");
  const [array, setArray] = useState([]);
  const [selectRowProp, setSelectRowProp] = useState([]);
  const [gamesTNT, setGamesTNT] = useState([]);
  const [name, setName] = useState("");
  const [selectGameModify, setSelectGameModify] = useState("Both")
  const [selectedOptions, setSelectedOptions] = useState({
    Date: false,
    League: false,
    Type: false,
  });

  // useEffect(() => {
  //   if(props.IdSport === "TNT"){
  //     const url =
  //       process.env.REACT_APP_API2_URL +
  //       "/Game/Games_GameDataTNTV2?idGame=" +
  //       props.IdGames[0] +
  //       "&idLineType=" +
  //       props.IdLinetype;

  //     axios
  //       .get(url)
  //       .then((response) => response.data)
  //       .then((data) => {
  //         setArray(data);
  //       });
  //   }
  // }, []);
  useEffect(() => {
    console.log(selectedOptions)
  }, [selectedOptions])

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setSelectedOptions((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleChangeGameDateTime = (event) => {
    setGameDateTime(event.target.value);
  };
  const handleChangeFamilyGame = (event) => {
    setFamilyGame(event.target.value);
  };

  const handleChangeParentGame = (event) => {
    setParentGame(event.target.value);
  };
  const handleChangeOdds = (event) => {
    setOdds(event.target.value);
  };
  const handleFindParent = (event) => {
    //TODO
  };

  const handleChangeDescription = (event) => {
    setDescription(event.target.value);
  };

  const handleChangeVisitorNumber = (event) => {
    setVisitorNumber(event.target.value);
  };

  const handleChangeVisitorTeam = (event) => {
    setVisitorTeam(event.target.value.toUpperCase());
  };

  const handleChangeHomeNumber = (event) => {
    setHomeNumber(event.target.value);
  };
  const handleChangeHomeTeam = (event) => {
    setHomeTeam(event.target.value.toUpperCase());
  };

  const handleChangeVisitorSpread = (event) => {
    setVisitorSpread(event.target.value);
  };

  const handleChangeVisitorSpreadOdds = (event) => {
    setVisitorSpreadOdds(event.target.value);
  };

  const handleChangeOverTotal = (event) => {
    setOverTotal(event.target.value);
  };

  const handleChangeOverOdds = (event) => {
    setOverOdds(event.target.value);
  };

  const handleChangeContender = (event) => {
    setContender(event.target.value);
  };
  const handleChangeName = (event) => {
    setName(event.target.value);
  };

  const handleChangeVisitorMoneyline = (event) => {
    setValueHasChanged(true);
    setVisitorMoneyline(event.target.value);
    setNewMoneyline(event.target.value);
  };

  const handleArray = () => {
    debugger
    let p = array.slice();
    p.push({ Id: contender, TeamName: name, Odds: odds });
    axios({
      method: "post",
      // url: 'https://localhost:44337/api/Game/InsertGameValuesTNT?idGame=' + IdGame,
      url:
        process.env.REACT_APP_API2_URL +
        "/Game/InsertGameValuesTNT?idGame=" +
        props.IdGames[0],
      data: [{ Id: contender, TeamName: name, Odds: odds }],
    }).then((response) => {
      setArray(p);
      setContender(parseInt(contender) + 1);

    });

  };


  const KeyPress = (event, side) => {
    if (event.key == "Enter" && side == "V") {
      setNewMoneyline(event.target.value);
      if (flag) {
        setFlag(false);
        setIsChange(true);
      } else {
        props.updateML(
          props.IdGames[0],
          visitorMoneyline,
          props.IdLinetype,
          event.target.value,
          props.IdSport.trim(),
          visitorNumber,
          4,
          8,
          1,
          0,
          homeNumber,
          typeID,
          8,
          5,
          leagueID
        );
      }
    } else if (event.key == "Enter" && side == "H") {
      setNewMoneyline(event.target.value);
      if (flag) {
        setFlag(false);
        setIsChange(true);
      } else {
        props.updateML(
          props.IdGames[0],
          homeMoneyline,
          props.IdLinetype,
          event.target.value,
          props.IdSport.trim(),
          visitorNumber,
          5,
          8,
          1,
          0,
          homeNumber,
          typeID,
          8,
          4,
          leagueID
        );
      }
    }
  };

  const handleChangeHomeSpread = (event) => {
    setHomeSpread(event.target.value);
  };

  const handleChangeHomeSpreadOdds = (event) => {
    setHomeSpreadOdds(event.target.value);
  };

  const handleChangeUnderTotal = (event) => {
    setUnderTotal(event.target.value);
  };

  const handleChangeUnderOdds = (event) => {
    setUnderOdds(event.target.value);
  };

  const handleChangeHomeMoneyline = (event) => {
    setValueHasChanged(true);
    setHomeMoneyline(event.target.value);
    setNewMoneyline(event.target.value);
  };

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
    setOpen(false);
    // console.log(props.datesRow)
  };

  const handleOk = async () => {
    if (gameStat != "B") {
      setIsLoading(true);
      if (props.IdGames.length > 1) {
        const defaultDate = gameDateTime.date ? gameDateTime.date.slice(0, -4) : gameDateTime;
        for (let i = 0; i < props.IdGames.length; i++) {
          let dateGame = props.datesRow && props.datesRow[i]?.gameDateTime && !selectedOptions.Date
            ? props.datesRow[i].gameDateTime
            : defaultDate;

          let idLeague = !selectedOptions.League ? props.datesRow[i]?.idLeague : leagueID;
          let idType = !selectedOptions.Type ? props.datesRow[i]?.idGameType : typeID;
          // let newDate = selectedOptions.Date ? 
          await axios({
            method: "post",
            url:
              process.env.REACT_APP_API2_URL +
              "/Game/UpdateGameMasive?idLeague=" +
              idLeague +
              "&date=" +
              dateGame +
              "&idGame=" +
              props.IdGames[i] +
              "&idUser=" +
              userInfo.userId +
              "&gameType=" +
              idType,
          }).then((response) => {
            props.searchGameValues();
            handleClose();
            props.resetDatesRow();
          });
        }
      } else if (flag) {
        // setVisitorPitcherOld(visitorPitcher);
        // setHomePitcherOld(homePitcher);
        setFlag(false);
        setIsChange(true);
      } else {
        let objTsend = {
          IdGame: idGame,
          IdSport: props.IdSport.trim(),
          IdLeague: leagueID,
          IdGameType: typeID,
          GameDateTime: gameDateTime,
          VisitorNumber: visitorNumber,
          HomeNumber: homeNumber,
          VisitorTeam: visitorTeam,
          HomeTeam: homeTeam,
          VisitorScore: visitorScore,
          HomeScore: homeScore,
          VisitorPitcher: visitorPitcher,
          HomePitcher: homePitcher,
          NormalGame: normalGame,
          GameStat: gameStat,
          Graded: graded,
          Hookups: hookups,
          Local: local,
          Online: online,
          ShortGame: shortGame,
          EventDate: eventDate,
          DateChanged: dateChanged,
          TimeChanged: timeChanged,
          PitcherChanged: pitcherChanged,
          Period: period,
          ParentGame: parentGame,
          GradedDate: gradedDate,
          NumTeams: numTeams,
          IdEvent: idEvent,
          FamilyGame: familyGame,
          HasChildren: hasChildren,
          IdTeamVisitor: idTeamVisitor,
          IdTeamHome: idTeamHome,
          IdBannerType: idBannerType,
          Description: description,
          AcceptAutoChanges: acceptAutoChanges,
          IdUser: userInfo.userId,
          Result: result,
        };
        await axios({
          method: "post",
          url: process.env.REACT_APP_API2_URL + "/Game/GameUpdate",
          data: objTsend,
        }).then((response) => {
          props.searchGameValues();
          setIsLoading(false);
          handleClose();
          props.resetDatesRow();
        });
      }
    }
  };

  // useEffect(()=>{
  //   console.log(props)
  // },[])

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API2_URL + "/GameType/GameType_Get")
      .then((response) => response.data)
      .then((data) => {
        const sorted = [...data].sort((a, b) => {
          const descA = (a.description || "").trim();
          const descB = (b.description || "").trim();
          const numA = parseInt(descA, 10);
          const numB = parseInt(descB, 10);
          const isNumA = !isNaN(numA);
          const isNumB = !isNaN(numB);
          if (isNumA && isNumB) return numA !== numB ? numA - numB : descA.localeCompare(descB);
          if (isNumA) return -1;
          if (isNumB) return 1;
          return descA.localeCompare(descB);
        });
        setType(sorted);
      });
  }, []);

  useEffect(() => {
    if (props.IdGames.length > 0) {
      axios({
        method: "GET",
        url:
          process.env.REACT_APP_API2_URL +
          "/Game/Games_GameData?idGame=" +
          props.IdGames[0] +
          "&idLineType=" +
          props.IdLinetype,
      })
        .then((response) => response.data)
        .then((data) => {
          data.forEach((x) => {
            setIdGame(x["idGame"]);
            setVisitorTeam(x["visitorTeam"]);
            setHomeTeam(x["homeTeam"]);
            setIdSport(x["idSport"]);
            setIdLeague(x["idLeague"]);
            setIdGameType(x["idGameType"]);
            setIdEvent(x["idEvent"]);
            setGameDateTime(x["gameDateTime"]);
            setNormalGame(x["normalGame"]);
            setVisitorNumber(x["visitorNumber"]);
            setHomeNumber(x["homeNumber"]);
            setGameStat(x["gameStat"]);
            setGraded(x["graded"]);
            setHookUps(x["hookUps"]);
            setOnline(x["online"]);
            setLocal(x["local"]);
            setShortGame(x["shortGame"]);
            setEventDate(x["eventDate"]);
            setDateChanged(x["dateChanged"]);
            setTimeChanged(x["timeChanged"]);
            setPeriod(x["period"]);
            setFamilyGame(x["familyGame"]);

            setParentGame(x["parentGame"]);
            setHasChildren(x["hasChildren"]);
            setVisitorScore(x["visitorScore"]);
            setHomeScore(x["homeScore"]);
            setVisitorPitcher(x["visitorPitcher"]);
            setVisitorPitcherOld(x["visitorPitcher"]);
            setHomePitcher(x["homePitcher"]);
            setHomePitcherOld(x["homePitcher"]);
            setGradedDate(x["gradedDate"]);
            setNumTeams(x["numTeams"]);
            setPitcherChanged(x["pitcherChanged"]);

            setIdTeamVisitor(x["idTeamVisitor"]);
            setIdTeamHome(x["idTeamHome"]);
            setIdBannerType(x["idBannerType"]);
            setDescription(x['gameDescription']);
            setTypeID(x["idGameType"]);
            setLeagueID(x["idLeague"]);

            setVisitorSpread(x["visitorSpread"]);
            setVisitorSpreadOdds(x["visitorSpreadOdds"]);
            setOverTotal(x["overTotal"]);
            setOverOdds(x["overOdds"]);
            setVisitorMoneyline(x["visitorMoneyline"]);
            setHomeSpread(x["homeSpread"]);
            setHomeSpreadOdds(x["homeSpreadOdds"]);
            setUnderTotal(x["underTotal"]);
            setUnderOdds(x["underOdds"]);
            setHomeMoneyline(x["homeMoneyline"]);
            setAcceptAutoChanges(x["acceptAutoChanges"])
          });
        })
        .then(() => {
          const url =
            process.env.REACT_APP_API2_URL +
            "/League/League_GetLeaguesByIdSport?idSport=" +
            props.IdSport.trim();
          axios
            .get(url)
            .then((response) => response.data)
            .then((data) => {
              const sortedData = data.sort((a, b) => {
                if (a.leagueOrder !== b.leagueOrder) {
                  return a.leagueOrder - b.leagueOrder;
                }
                return a.description.localeCompare(b.description);
              });
              setLeague(sortedData);
            });
        })
        .then(() => {
          const url = process.env.REACT_APP_API2_URL + "/Game/Pitcher_GetList";
          axios
            .get(url)
            .then((response) => response.data)
            .then((data) => {
              let PitchersInfo = data.map((v) => {
                v.idSport = v.pitcherName;
                return v;
              });
              setPitchers(PitchersInfo);
            }).then(() => {
              const url =
                process.env.REACT_APP_API2_URL +
                "/Game/Games_GameDataTNTV2?idGame=" +
                props.IdGames[0] +
                "&idLineType=" +
                props.IdLinetype;

              axios
                .get(url)
                .then((response) => response.data)
                .then((data) => {
                  let p = array.slice();
                  let i = 0;
                  data.forEach((d) => {

                    p.push({ Id: d.teamNumber, TeamName: d.teamName, Odds: d.odds });
                    i = d.teamNumber;

                  });
                  i++;
                  setArray(p);
                  setContender(i);
                });
            })
            .then(setLoading(false));
        });
    }
  }, [props.IdGames, props.IdLinetype, props.IdSport]);

  function changeLeagueID(value) {
    setLeagueID(value);
  }

  const setVisitorPitcherOnMem = (VisitorPitcher) => {
    setVisitorPitcher(VisitorPitcher);
    setFlag(true);
    setIdAction(1);
    setPitcherSide("V");
    setPitcherChanged(3);
  };
  const setHomePitcherOnMem = (HomePitcher) => {
    setHomePitcher(HomePitcher);
    setFlag(true);
    setIdAction(2);
    setPitcherSide("H");
    setPitcherChanged(3);
  };
  function changeTypeID(value) {
    setTypeID(value);
  }

  const pitcherChanging = () => {
    if (pitcherSide == "V" && visitorMoneyline != 0 && visitorMoneyline != null) {
      props.updateML(
        props.IdGames[0], visitorMoneyline, props.IdLinetype, newMoneyline,
        props.IdSport.trim(), visitorNumber, 4, 8, 1, 0, homeNumber, typeID, 8, 5, leagueID
      );
    } else if (pitcherSide == "H" && homeMoneyline != 0 && homeMoneyline != null) {
      props.updateML(
        props.IdGames[0], homeMoneyline, props.IdLinetype, newMoneyline,
        props.IdSport.trim(), visitorNumber, 5, 8, 1, 0, homeNumber, typeID, 8, 4, leagueID
      );
    }

    let request = {
      idGame: props.IdGames[0],
      idAction: idAction,
      oldPitcher: pitcherSide == "V" ? visitorPitcherOld : homePitcherOld,
      newPitcher: pitcherSide == "V" ? visitorPitcher : homePitcher,
      idUser: userInfo.userId,
      visitorMoneyline: visitorMoneyline,
      homeMoneyline: homeMoneyline,
      pitcher: pitcherSide,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_APIGRADE_URL + "/PitcherChange/PitcherChanging",
      //url: 'https://localhost:44337/api/Game/PitcherChanging',

      data: request,
    }).then((response) => {
      // props.searchGameValues();
      handleClose();
      setFlag(false);
      handleOk();
    });
  };

  const handleCloseIsChange = function () {
    setIsChange(false);
  };

  const handleChangeRadio = (event) => {
    setSelectGameModify(event.target.value);
  };


  const contenderColumns = [
    {
      dataField: "Id",
      text: "ID",
      editable: false,
      formatter: (cell, rowIndex, columnIndex, formatExtraData) => {
        return <div style={{ fontSize: "16px" }}>{cell}</div>;
      },
    },
    {
      dataField: "TeamName",
      text: "NAME",
      editable: true,
      formatter: (cell, rowIndex, columnIndex, formatExtraData) => {
        return <div style={{ fontSize: "16px" }}>{cell}</div>;
      },
    },
    {
      dataField: "Odds",
      text: "ODDS",
      editable: false,
      formatter: (cell, rowIndex, columnIndex, formatExtraData) => {
        return <div style={{ fontSize: "16px" }}>{cell}</div>;
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      isDummyField: true, // Dummy field for custom renderers
      editable: false,
      formatter: (cell, row) => (
        <div style={{ display: "flex", gap: "10px", justifyContent: "center", alignItems: "center" }}>
          <FaSave
            style={{ color: "green", cursor: "pointer", fontSize: "20px" }}
            onClick={() => handleSave(row)}
          />
          <FaTrash
            style={{ color: "red", cursor: "pointer", fontSize: "20px" }}
            onClick={() => handleDelete(row.Id)}
          />
        </div>
      ),
    },
  ];

  const handleSave = (row) => {
    setIsLoading(true);
    console.log("Save clicked for row:", row);
    let request = {
      teamNumber: row.Id,
      teamName: row.TeamName
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Game/UpdateContenderTNT",
      //url: 'https://localhost:44337/api/Game/PitcherChanging',

      data: request,
    }).then((response) => {
      setIsLoading(false);
    });
  };

  const handleDelete = (rowId) => {
    debugger;
    console.log("Delete clicked for row ID:", rowId);
    setIsLoading(true);
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Game/DeleteContenderTNT?teamNumber=" + rowId,

    }).then((response) => {

      setArray((array) => array.filter((row) => row.Id !== rowId));

      setIsLoading(false);
    });
  };


  return (
    <React.Fragment>
      {isChange ? (
        <PitcherChangeConfirm
          onClose={handleCloseIsChange}
          postChange={pitcherChanging}
        />
      ) : (
        ""
      )}
      <Dialog open={open} onClose={handleClose}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Game Modify
            </Typography>
          </Toolbar>
        </AppBar>
        {loading ? (
          <CircularProgress style={{ margin: "0 auto" }} />
        ) : (
          <React.Fragment>
            <br />
            <form className={classes.center}>
              <FormGroup row>
                {
                  // props.IdGames.length == 1 &&

                  <TextField
                    variant="outlined"
                    id="gameDateTime"
                    label="Game Date and Time"
                    type="datetime-local"
                    value={
                      gameDateTime
                        ? gameDateTime.replace(" ", "T").split(".")[0]
                        : gameDateTime
                    }
                    onChange={handleChangeGameDateTime}
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                }
                <Divider />
                <FormControl
                  className={`${classes.formControl} w-full`}
                  size="small"
                  variant="outlined"
                >
                  {leagueID != 0 ? (
                    <InputSelect
                      size="small"
                      variant="outlined"
                      name="name"
                      label="League"
                      data={league}
                      placeholder="League"
                      setSelectValue={changeLeagueID}
                      startValue={leagueID}
                    />
                  ) : (
                    ""
                  )}
                </FormControl>
              </FormGroup>
              <FormGroup row>
                <FormControl
                  className={`${classes.formControl} w-full`}
                  size="small"
                  variant="outlined"
                >
                  {typeID != 0 ? (
                    <InputSelect
                      size="small"
                      variant="outlined"
                      name="name"
                      label="Type"
                      data={type}
                      placeholder="Type"
                      setSelectValue={changeTypeID}
                      startValue={typeID}
                    />
                  ) : (
                    ""
                  )}
                </FormControl>
              </FormGroup>
              <Divider />
              {/* { props.IdGames.length > 1 && 
                    <div className="flex flex-col gap-2  pt-3 py-3 items-center">
                      <label className="flex text-left text-sm ">Change:</label>
                      <div className="flex gap-4">
                        <label className="flex gap-4 text-sm">
                          <input
                            type="radio"
                            name="selection"
                            value="League"
                            checked={selectGameModify == "League"}
                            onChange={handleChangeRadio}
                          />
                          League
                        </label>
                        <label className="flex gap-4 text-sm">
                          <input
                            type="radio"
                            name="selection"
                            value="Type"
                            checked={selectGameModify == "Type"}
                            onChange={handleChangeRadio}
                          />
                          Type
                        </label>
                        <label className="flex gap-3 text-sm">
                          <input
                            type="radio"
                            name="selection"
                            value="Both"
                            checked={selectGameModify == "Both"}
                            onChange={handleChangeRadio}
                          />
                          Both
                        </label>
                      </div>
                  </div>
                } */}
              {props.IdGames.length > 1 && (
                <div className="flex flex-col gap-2 pt-3 py-3 items-center">
                  <label className="flex text-left text-sm">Change:</label>
                  <div className="flex gap-4">
                    {["Date", "League", "Type"].map((option) => (
                      <label key={option} className="flex gap-2 text-sm">
                        <input
                          type="checkbox"
                          name={option}
                          checked={selectedOptions[option]}
                          onChange={handleCheckboxChange}
                        />
                        {option}
                      </label>
                    ))}
                  </div>
                </div>
              )}

              {props.IdGames.length == 1 ? (
                <React.Fragment>
                  <FormGroup row>
                    <TextField
                      type="number"
                      label="Family Game"
                      value={familyGame}
                      multiline={true}
                      onChange={handleChangeFamilyGame}
                      variant="outlined"
                    />

                    <Button
                      className={classes.button}
                      disabled
                      variant="contained"
                      onClick={handleFindParent}
                      startIcon={<SearchIcon />}
                    >
                      Find
                    </Button>
                  </FormGroup>
                  <Divider />

                  <FormGroup row>
                    <TextField
                      type="number"
                      label="Parent Game"
                      value={parentGame}
                      multiline={true}
                      onChange={handleChangeParentGame}
                      variant="outlined"
                    />
                    <Button
                      disabled
                      className={classes.button}
                      variant="contained"
                      onClick={handleFindParent}
                      startIcon={<SearchIcon />}
                    >
                      Find
                    </Button>
                  </FormGroup>
                  <Divider />
                  <FormGroup row>
                    <TextField
                      fullWidth
                      type="text"
                      label="Description"
                      value={description}
                      multiline={true}
                      rows="4"
                      onChange={handleChangeDescription}
                      variant="outlined"
                    />
                  </FormGroup>
                  <Divider />


                  {props.IdSport == "TNT" || props.IdSport == "PROP" ? (
                    <React.Fragment>
                      {" "}
                      {props.IdSport == "TNT" ? (
                        <FormGroup column>
                          <Table>
                            <TableRow className={classes.mobileTabl}>
                              <TableCell className={classes.mobileTablTd}>
                                <TextField
                                  variant="outlined"
                                  type="number"
                                  label="Contenders #"
                                  value={contender}
                                  multiline={false}
                                  onChange={handleChangeContender}
                                  className={classes.mobileTablTd}
                                />
                              </TableCell>
                              <TableCell className={classes.mobileTablTd}>
                                <TextField
                                  variant="outlined"
                                  type="text"
                                  label="Name"
                                  value={name}
                                  multiline={false}
                                  onChange={handleChangeName}
                                  className={classes.mobileTablTd}
                                />
                              </TableCell>
                              <TableCell className={classes.mobileTablTd}>
                                <TextField
                                  variant="outlined"
                                  type="number"
                                  label="Odds"
                                  value={odds}
                                  multiline={false}
                                  onChange={handleChangeOdds}
                                  className={classes.mobileTablTd}
                                />
                              </TableCell>
                              <TableCell className={classes.mobileTablTd}>
                                <Button color="inherit" onClick={handleArray} className={`${classes.mobileTablTd} ${classes.BtnAdd}`}>
                                  Add
                                </Button>
                              </TableCell>
                            </TableRow>
                          </Table>
                          <Table>
                            <TableRow>
                              <BootstrapTable
                                keyField="Id"
                                data={array}
                                //selectRow={selectRowProp}
                                columns={contenderColumns}
                                cellEdit={cellEditFactory({
                                  mode: "click",
                                  blurToSave: false
                                })}
                              >
                                <TableHeaderColumn isKey={true} dataField="Id">
                                  ID
                                </TableHeaderColumn>
                                <TableHeaderColumn dataField="TeamName">
                                  Name
                                </TableHeaderColumn>
                                <TableHeaderColumn dataField="Odds">
                                  Odds
                                </TableHeaderColumn>
                              </BootstrapTable>
                            </TableRow>
                          </Table>
                        </FormGroup>
                      ) : (
                        <FormGroup row>
                          <Table>
                            <TableRow>
                              <TableCell>
                                <TextField
                                  variant="outlined"
                                  type="number"
                                  label="Number"
                                  value={visitorNumber}
                                  multiline={true}
                                  onChange={handleChangeNumber}
                                />
                              </TableCell>
                              <TableCell>
                                <TextField
                                  variant="outlined"
                                  type="text"
                                  label="Type"
                                  value={visitorTeam}
                                  multiline={true}
                                  onChange={handleChangeType}
                                />
                              </TableCell>
                              <TableCell>
                                <TextField
                                  variant="outlined"
                                  type="text"
                                  label="Participant"
                                  value={homeTeam}
                                  multiline={true}
                                  onChange={handleChangeHomeTeam}
                                />
                              </TableCell>
                              <TableCell>
                                <TextField
                                  variant="outlined"
                                  type="number"
                                  label="Odds"
                                  value={odds}
                                  multiline={true}
                                  onChange={handleChangeOdds}
                                />
                              </TableCell>
                            </TableRow>
                          </Table>
                        </FormGroup>
                      )}{" "}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <FormGroup row>
                        <TextField
                          type="number"
                          label="Visitor Team #"
                          value={visitorNumber}
                          multiline={true}
                          onChange={handleChangeVisitorNumber}
                          variant="outlined"
                        />

                        <FormControl
                          className={`${classes.formControl} w-full`}
                          size="small"
                          variant="outlined"
                        >
                          <TextField
                            variant="outlined"
                            type="text"
                            label="Visitor Team"
                            value={visitorTeam}
                            multiline={true}
                            onChange={handleChangeVisitorTeam}
                          />
                        </FormControl>
                      </FormGroup>
                      <FormGroup row>
                        <TextField
                          variant="outlined"
                          type="number"
                          label="Home Team #"
                          value={homeNumber}
                          multiline={true}
                          onChange={handleChangeHomeNumber}
                        />

                        <FormControl
                          className={`${classes.formControl} w-full`}
                          size="small"
                          variant="outlined"
                        >
                          <TextField
                            variant="outlined"
                            type="text"
                            label="Home Team"
                            value={homeTeam}
                            multiline={true}
                            onChange={handleChangeHomeTeam}
                          />
                        </FormControl>
                      </FormGroup>
                      {props.IdSport.trim() == "MLB" ? (
                        <FormGroup row>
                          <FormControl
                            className={`${classes.formControl} w-full`}
                            size="small"
                            variant="outlined"
                          >
                            <PitcherSearch
                              isInput={true}
                              initialValue={visitorPitcher}
                              setPitcherOnMem={setVisitorPitcherOnMem}
                            ></PitcherSearch>

                          </FormControl>
                          <FormControl
                            className={`${classes.formControl} w-full`}
                            size="small"
                            variant="outlined"
                          >
                            <PitcherSearch
                              isInput={true}
                              initialValue={homePitcher}
                              setPitcherOnMem={setHomePitcherOnMem}
                            ></PitcherSearch>
                          </FormControl>
                        </FormGroup>
                      ) : (
                        ""
                      )}
                      {props.IdSport.trim() == "MLB" ? (
                        <FormGroup row>
                          <FormControl
                            className={`${classes.formControl} w-full`}
                            size="small"
                            variant="outlined"
                          >
                            <DelayInput
                              placeholder="Visitor ML"
                              minLength={1}
                              delayTimeout={2000}
                              onKeyDown={(event) => {
                                KeyPress(event, "V");
                              }}
                              className={` ${" schedule-text-box-input"} `}
                              value={
                                visitorMoneyline == 0 || visitorMoneyline == null
                                  ? ""
                                  : visitorMoneyline
                              }
                              /*onBlur={(event) => {
                            updateML(event.target.value, 0);
                          }}*/
                              onChange={handleChangeVisitorMoneyline}
                            />
                          </FormControl>
                          <FormControl
                            className={`${classes.formControl} w-full`}
                            size="small"
                            variant="outlined"
                          >
                            <DelayInput
                              placeholder="Home ML"
                              minLength={1}
                              delayTimeout={2000}
                              className={` ${props.IdSport.trim() == "TNT" ||
                                  props.IdSport.trim() == "PROP"
                                  ? "schedule-text-box-input-tnt"
                                  : " schedule-text-box-input"
                                } `}
                              value={
                                homeMoneyline == 0 || homeMoneyline == null
                                  ? ""
                                  : homeMoneyline
                              }
                              onKeyDown={(event) => {
                                KeyPress(event, "H");
                              }}
                              /*onBlur={(event) => {
                            updateML(event.target.value, 1);
                          }}*/
                              onChange={handleChangeHomeMoneyline}
                            />
                          </FormControl>
                        </FormGroup>
                      ) : (
                        ""
                      )}
                    </React.Fragment>
                  )}{" "}



                </React.Fragment>
              ) : (
                ""
              )}
            </form>
          </React.Fragment>
        )}
        <DialogActions>
          {isLoading ? (
            <Loader height={100} width={100}></Loader>
          ) : (
            <div>
              <Button
                color="inherit"
                startIcon={<CancelIcon />}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                startIcon={<SaveIcon />}
                variant="contained"
                color="primary"
                onClick={handleOk}
              >
                Ok
              </Button>
            </div>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
